import { PHONE_NO_REGEX } from 'global/appConstants';
import yup from 'utils/yup';

export const initialEmployeeFormData = {
  id: '',
  employee_custom_id: '',
  first_name: '',
  middle_name: '',
  last_name: '',
  ssn: '',
  email: '',
  phone: '',
  position: '',
  address_line_1: '',
  address_line_2: '',
  state: '',
  city: '',
  zip: '',
  hiring_date: null as any,
  termination_date: null as any,
  shift_start_time: null as any,
  shift_end_time: null as any,
};

export const employeeFormValidationSchema = yup.object().shape({
  first_name: yup.string().required(),
  last_name: yup.string().required(),
  employee_custom_id: yup.string().required(),
  email: yup.string().email().required(),
  ssn: yup.string().required(),
  address_line_1: yup.string().required(),
  state: yup.string().required(),
  city: yup.string().required(),
  zip: yup
    .string()
    .matches(/^\d{5}(-\d{4})?$/, 'Enter valid zip code')
    .required(),
  phone: yup.string().matches(PHONE_NO_REGEX, () => ({ msg: 'common:yup.default' })),
});
